// src/components/PaymentDetails.js (CÓDIGO CORREGIDO: NUEVO WHATSAPP NUMBER)

import React, { useState } from 'react';
import { FaMoneyBillWave, FaGlobe, FaCalendarCheck } from 'react-icons/fa';

// Datos de pago (basados en tu imagen anterior)
const PAYMENT_INFO = {
    pagoMovil: {
        monto: "Monto: **$50.00 USD** o equivalente en Bs. (Consultar tasa del día).",
        banco: "Banco: **0102** (Banco de Venezuela)**",
        // 🛑 MANTENEMOS EL NÚMERO DE PAGO MÓVIL VENEZOLANO AQUÍ
        telefono: "Teléfono: **0424-300-9284**", 
        cedula: "Cédula/RIF: **V-16.129.666**"
    },
    zelle: "Si deseas pagar en dólares o desde el extranjero, usa Zelle o transferencia internacional.",
};

// 🛑 CORRECCIÓN: Usando el número +1 (407) 873-8172 para el enlace de agendamiento
const WHATSAPP_NUMBER_AGENDAR = '14078738172'; 
const WHATSAPP_MESSAGE_AGENDAMIENTO = 'Hola, ya realicé mi pago. Mi nombre es [TU NOMBRE], mi correo es [TU CORREO] y adjunto el comprobante para agendar mi consulta.';
const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER_AGENDAR}?text=${encodeURIComponent(WHATSAPP_MESSAGE_AGENDAMIENTO)}`;


const PaymentDetails = ({ price, serviceName }) => {
    const [showZelleData, setShowZelleData] = useState(false);
    
    // Ajusta la info de Pago Móvil si el precio cambia
    const currentPagoMovilInfo = {
        ...PAYMENT_INFO.pagoMovil,
        monto: `Monto: **${price}** o equivalente en Bs. (Consultar tasa del día).`
    };

    return (
        <div className="payment-steps-container">
            
            <h3><FaMoneyBillWave /> 1. Elige Tu Método de Pago</h3>
            
            {/* --- Pago Móvil --- */}
            <div className="payment-method">
                <h4>PAGO MÓVIL (Venezuela)</h4>
                <p dangerouslySetInnerHTML={{ __html: currentPagoMovilInfo.monto }} />
                <p dangerouslySetSetInnerHTML={{ __html: currentPagoMovilInfo.banco }} />
                <p dangerouslySetInnerHTML={{ __html: currentPagoMovilInfo.telefono }} />
                <p dangerouslySetInnerHTML={{ __html: currentPagoMovilInfo.cedula }} />
            </div>

            {/* --- Zelle / Transferencia Internacional --- */}
            <div className="payment-method international">
                <h4><FaGlobe /> Zelle / Transferencia Internacional</h4>
                <p>{PAYMENT_INFO.zelle}</p>
                
                <button 
                    className="cta-button primary"
                    onClick={() => setShowZelleData(!showZelleData)}
                    style={{ width: 'auto' }}
                >
                    {showZelleData ? "Ocultar Datos" : "Solicitar Datos de Zelle/Transferencia"}
                </button>
                
                {showZelleData && (
                    <div className="zelle-data-placeholder" style={{ marginTop: '15px', padding: '10px', border: '1px dashed #ccc', backgroundColor: '#fff' }}>
                        <p>Por favor, revisa tu correo electrónico para los datos de pago internacionales, o contáctanos vía WhatsApp.</p>
                    </div>
                )}
            </div>
            
            <hr style={{ margin: '30px 0' }} />
            
            <h3><FaCalendarCheck /> 2. Confirma y Agenda Tu Cita</h3>
            <p>
                Una vez realizado el pago (Pago Móvil o Internacional), por favor **envía tu comprobante junto con tu nombre completo y correo electrónico** a nuestro WhatsApp directo. Te contactaremos inmediatamente para **"agendar la hora y fecha"** de tu consulta.
            </p>

            <button 
                className="cta-button primary"
                // CORRECCIÓN: Abre el enlace de WhatsApp con el número +1
                onClick={() => window.open(WHATSAPP_LINK, '_blank')}
                style={{ marginTop: '20px', backgroundColor: '#25D366' }}
            >
                Enviar Comprobante y Agendar
            </button>
            
            <p style={{ marginTop: '20px', fontSize: '0.9em', color: '#888' }}>
                Tu adquisición es por: **{serviceName}** (Monto: {price}).
            </p>

        </div>
    );
};

export default PaymentDetails;